import i18n from '@i18next/i18n';
import React from 'react';
import Button from '@tencent/dui-mobile/lib/components/Button';
import RegionWrapper from '@com/region-wrapper';
import NOTE_DROP_ICON from '../../../editor/src/img/note-drop.png';
import MobilePopupWrapper, { PopupMenuType } from '@com-m/popup-wrapper-m';
import Style from './index.less';
import { NOTE_CANVAS_ID, NOTE_CONTAINER_ID } from '@com-pc/note-area-wrapper/constant';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import VIP_BACK from '@src/img/first-screen/background_svip_44.svg';
import VIP_BACK_MASK from '../../../../img/first-screen/titlebar-background-mask.svg';

import { isSupportNativeTitleBar } from '@src/js/manager/native-titlebar-manager';
import { IMobileNoteAreaProps, IMobileNoteAreaService, IMobileNoteAreaState } from '@src/slide/application/service/note-area-component/core/mobile/type';
import { NOTE_REF_NAME } from '@src/framework/frame/components/note-area/constant';
import ReactView from '@src/slide/infrastructure/module/independent/view-service-define/react/react-view';
import MobileNoteAreaModel from '@src/slide/application/service/note-area-component/core/mobile/mobile-note-area-model';
import { IMobileNoteAreaInfo } from '@src/slide/application/service/note-area-component/core/mobile/mobile-note-area-service.interface';

export default class MobileNoteAreaWrapper extends React.Component<IMobileNoteAreaProps, IMobileNoteAreaState> {
    public static displayName = 'MobileNoteAreaWrapper';

    private noteCanvasRef: HTMLCanvasElement | null;
    private noteTopRef: HTMLDivElement | null;
    private noteBottomRef: HTMLDivElement | null;
    private noteContainerRef: HTMLDivElement | null;
    private noteAreaService: IMobileNoteAreaService;

    public constructor(props: IMobileNoteAreaProps, content) {
        super(props, content);
        this.noteAreaService = props.getNoteAreaService();
        this.noteAreaService.setViewDelegate(new class extends ReactView<IMobileNoteAreaProps> {
            public getElementById(id: string) {
                const canvasComponent = this.realView as MobileNoteAreaWrapper;
                return canvasComponent.getRefByName(id);
            }
        }(this));
    }

    public componentDidMount(): void {
        this.noteAreaService.componentDidMount();
    }

    public componentDidUpdate(): void {
        this.noteAreaService.componentDidUpdate();
    }

    public componentWillUnmount(): void {
        this.noteAreaService.componentWillUnmount();
    }

    public getRefByName(name: string) {
        switch (name) {
            case NOTE_REF_NAME.NOTE_CANVAS:
                return this.noteCanvasRef;
            case NOTE_REF_NAME.NOTE_TOP:
                return this.noteTopRef;
            case NOTE_REF_NAME.NOTE_BOTTOM:
                return this.noteBottomRef;
            case NOTE_REF_NAME.NOTE_CONTAINER:
                return this.noteContainerRef;
        }
    }

    public getNoteAreaInfo(): IMobileNoteAreaInfo {
        return this.noteAreaService.getNoteAreaInfo();
    }

    public render() {
        const { mobileNoteShow, noteAreaHeight, editMode, tempClose } = this.getState();
        const { hideNote, handleButtonClick, handleButtonTouchEnd,
            getPopupStyle, getContainerStyle } = this.noteAreaService;
        const prefix = 'mobile-note-area';
        const vipStyle: React.CSSProperties = {};

        // 备注先屏蔽vip，后续看产品恢复
        const isVipTheme = false;
        // if (isVipTheme) {
        //     vipStyle.backgroundSize = 'cover';
        //     vipStyle.backgroundPosition = '0px 0px';
        //     vipStyle.backgroundImage = `url(${VIP_BACK})`;
        //     vipStyle.maskImage = `url(${VIP_BACK_MASK})`;
        //     vipStyle.maskSize = 'cover';
        //     vipStyle.width = 'calc(100%)';
        //     vipStyle.height = '56px';
        //     vipStyle.position = 'relative';
        // }

        return (
            <div
                className={Style[`${prefix}-wrapper`]}
                style={{
                    height: noteAreaHeight,
                    visibility: !mobileNoteShow || (tempClose && !editMode) ? 'hidden' : 'visible',
                }}
                onTouchStart={e => e.preventDefault()}
            >
                <RegionWrapper region={RegionType.NOTE}>
                    <MobilePopupWrapper
                        style={getPopupStyle()}
                    >
                        {editMode ? <div style={
                            {
                                position: 'absolute',
                                zIndex: 1,
                                background: 'white',
                                borderBottom: '1px solid rgba(0,0,0,.08)',
                                top: '0px',
                                height: '44px',
                                width: '100%',
                                ...vipStyle,
                            }}>
                            <Button
                                onClick={handleButtonClick} onTouchEnd={handleButtonTouchEnd}
                                style={{
                                    right: '12px',
                                    top: '6px',
                                    fontWeight: 600,
                                    position: 'absolute',
                                    fontSize: '16px',
                                    color: isVipTheme ? '#ffcd76' : '#1e6fff',
                                    background: isVipTheme ? 'transparent' : 'white',
                                }}>{i18n.t('完成')}</Button>
                        </div> : null}
                        {
                            <div ref={(ref) => {
                                this.noteContainerRef = ref;
                            }} id={NOTE_CONTAINER_ID} style={getContainerStyle()} className={`global-scroll ${Style['mobile-note-area-scroll']}`}>
                                <div ref={(ref) => {
                                    this.noteTopRef = ref;
                                }} />
                                <div style={{ position: 'relative' }}>
                                    <canvas
                                        ref={(ref) => {
                                            this.noteCanvasRef = ref;
                                        }}
                                        id={NOTE_CANVAS_ID}
                                        /**
                                         * canvas作为inline-block元素，高度与父元素一致时，base-line的对齐方式会导致底部内容超出，
                                         * 父元素会出现滚动条，因此这里需要设置 verticalAlign 使底部与整行的底部对齐。
                                         */
                                        style={{ left: 0, top: 0, verticalAlign: 'bottom' }}
                                    />
                                </div>
                                <div ref={(ref) => {
                                    this.noteBottomRef = ref;
                                }} />
                            </div>
                        }
                        { editMode ? null : <div
                            className={Style[`${prefix}-icon-wrapper`]}
                        >
                            <img
                                className={Style[`${prefix}-icon`]}
                                onClick={hideNote}
                                src={NOTE_DROP_ICON}
                            />
                        </div>}
                    </MobilePopupWrapper>
                </RegionWrapper>
            </div>
        );
    }

    private getVipInfoService() {
        return (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
            .viewableServiceLayer.vipInfoService;
    }

    private getState() {
        const state = this.noteAreaService?.getModel();
        return state as MobileNoteAreaModel;
    }
}
